<template>
  <div
    class="flex flex-col overflow-visible"
    :class="{
      'bordered-title': bordered,
      'bg-gradient': useBg,
    }"
  >
    <ResourceLinkWrapper
      :link="useLink && link"
      :open-in-new-tab="true"
      class="cursor-pointer"
    >
      <div class="flex items-center">
        <span class="resource-name-pill">{{ resource.name }}</span>
        <small class="text-neutral text-ellipsis">{{ resource.subject }}</small>
      </div>
    </ResourceLinkWrapper>
    <ResourceListTitle
      class="mt-2"
      :created-at="resource.createdAt"
      :requester-name="resource.requesterData.name"
      :requester-email="resource.requesterData.email"
      :owner-id="resource.requesterId || resource.technicianId"
      open-in-new-tab
      :link="useLink && link"
      :user-id="resource.technicianId"
    >
      <template v-slot:below-title>
        <!-- <MTooltip>
          <template v-slot:trigger>
            <MIcon name="status" size="lg" class="mr-2 text-neutral-light" />
          </template>
          {{ $t('status') }}
        </MTooltip> -->
        <FlotoDotSeparator class="mx-2" />
        <small class="text-neutral-light mr-2">
          {{ $t('status') }}
        </small>
        <ProjectStatusPicker
          v-if="moduleName === $constants.PROJECT"
          disabled
          :value="resource.projectStatus"
        />
        <FlotoStatusPicker
          v-else
          :module-name="moduleName"
          :value="resource.statusId"
          disabled
        />
        <FlotoDotSeparator class="mx-2" />
        <small class="text-neutral-light mx-2">
          {{ $t('priority') }}
        </small>
        <FlotoPriorityPicker
          :value="resource.priorityId"
          disabled
          placeholder="---"
        />
        <!-- <div class="flex-1 flex items-center">
        <MTooltip>
          <template v-slot:trigger>
            <MIcon name="priority" size="lg" class="mr-2 text-neutral-light" />
          </template>
          {{ $t('priority') }}
        </MTooltip>
<FlotoDotSeparator class="mx-2" />

        <FlotoPriorityPicker
          :value="resource.priorityId"
          disabled
          placeholder="---"
        />
      </div> -->
      </template>
    </ResourceListTitle>
  </div>
</template>

<script>
import ProjectStatusPicker from '@components/data-picker/project-status-picker'
import ResourceListTitle from './resource-list-title'
import ResourceLinkWrapper from './resource-link-wrapper'

export default {
  name: 'ResourceListTitleWithStatus',
  components: { ResourceListTitle, ProjectStatusPicker, ResourceLinkWrapper },
  props: {
    moduleName: { type: String, required: true },
    resource: { type: Object, required: true },
    useLink: { type: Boolean, default: false },
    link: { type: [String, Object], default: undefined },
    bordered: { type: Boolean, default: false },
    useBg: { type: Boolean, default: false },
  },
}
</script>

<style lang="less" scoped>
.bordered-title {
  @apply p-3 rounded;

  border: 1px solid var(--border-color-light);
}
</style>
